import TransferResource from './transfer-resource';

const BASE_URL = '/account-holder/eotc';

export default function Resource({ base, fundingURL }) {
  return {
    Transfer: TransferResource({ base, url: `${fundingURL}${BASE_URL}` }),
  };
}
